import React from 'react';
import Form from './Form';
import { Col } from 'reactstrap';

export default () => {
  return <Col xs="12" md="6" lg="4" className="py-5">
    <Form />
  </Col>
}
